import { render } from "./ProfileSwitcher.vue?vue&type=template&id=4db1463e&scoped=true"
import script from "./ProfileSwitcher.vue?vue&type=script&lang=js"
export * from "./ProfileSwitcher.vue?vue&type=script&lang=js"

import "./ProfileSwitcher.vue?vue&type=style&index=0&id=4db1463e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db1463e"]])

export default __exports__